module.exports = __webpack_public_path__ + "img/cogs.ceb351e3.svg";